module.exports = __webpack_public_path__ + "static/media/Screenshot6.dd72a8a6.png";